/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1901854742 — Маршрутизація */

import { Route, Routes } from "react-router-dom";
import {
  CheckboxPage,
  CompletePage,
  ContactPage,
  FEEDBACK_ROUTES,
  SmilePage,
  WishesPage,
} from '../modules/feedback';
import { LoyaltyLayout } from '../modules/loyalty/layouts/LoyaltyLayout';
import {
  CompletedScreen,
  Connecting,
  FailureScreen,
  ORDER_ROUTES,
  RefundScreen,
} from '../modules/order';
import {
  CarWashScreen,
  PAYMENT_PAGES,
  PAYMENT_ROUTES,
  PaymentCT10Screen,
  PaymentCT5Screen,
  PaymentScreen,
  PulseScreen,
  SelectProduct,
  SnackScreen,
  WaitScreen,
  WaterScreen,
} from '../modules/payment';
import {
  SERVICE_ROUTES,
  ServiceComplete,
  ServiceFail,
  ServiceMain,
  ServiceRobot,
  ServiceWait,
} from '../modules/service';
import {
  Error404Screen,
  NotConnectedScreen,
  NotSupportedScreen,
  OldTabScreen,
  STATUS_ROUTES,
} from '../modules/status';
import { DevAnimations } from "../pages/DevAnimations/DevAnimations";
import { DevGame } from "../pages/DevGame/DevGame";
import { ScanQrCode } from "../pages/ScanQrCode/ScanQrCode";
import { APP_ROUTES, IS_LOCAL_DEVELOPMENT } from '../shared/constants';
import { Layout } from "../shared/layouts/Layout";

const AppRouter = () => {

  return (
    <Routes>
      <Route path={APP_ROUTES.home} element={<Layout />}>
        <Route index element={<ScanQrCode />} />
        <Route
          path={ORDER_ROUTES.connecting}
          element={<Connecting />}
        />
        <Route
          path={PAYMENT_ROUTES.select}
          element={
            <LoyaltyLayout>
              <SelectProduct />
            </LoyaltyLayout>
          }
        />
        <Route
          path={PAYMENT_ROUTES.snack}
          element={
            <LoyaltyLayout>
              <SnackScreen />
            </LoyaltyLayout>
          }
        />
        <Route
          path={PAYMENT_ROUTES.water}
          element={
            <LoyaltyLayout>
              <WaterScreen />
            </LoyaltyLayout>
          }
        />
        <Route
          path={PAYMENT_ROUTES.pulse}
          element={
            <LoyaltyLayout>
              <PulseScreen />
            </LoyaltyLayout>
          }
        />
        <Route
          path={PAYMENT_ROUTES.popcorn}
          element={
            <LoyaltyLayout>
              <PaymentScreen screenName={PAYMENT_PAGES.popcorn} />
            </LoyaltyLayout>
          }
        />
        <Route
          path={PAYMENT_ROUTES.payment}
          element={
            <LoyaltyLayout isBannerEnabled={false}>
              <PaymentScreen screenName="payment" />
            </LoyaltyLayout>
          }
        />
        <Route
          path={PAYMENT_ROUTES.paymentCT5}
          element={
            <LoyaltyLayout>
              <PaymentCT5Screen />
            </LoyaltyLayout>
          }
        />
        <Route
          path={PAYMENT_ROUTES.paymentCT10} 
          element={
            <LoyaltyLayout>
              <PaymentCT10Screen />
            </LoyaltyLayout>
          }
        />
        <Route
          path={PAYMENT_ROUTES.wait}
          element={<WaitScreen />}
        />
        <Route
          path={ORDER_ROUTES.success}
          element={
            <LoyaltyLayout isBalanceEnabled={false}>
              <CompletedScreen />
            </LoyaltyLayout>
          }
        />
        <Route
          path={ORDER_ROUTES.failed}
          element={<FailureScreen screenName="failed" />}
        />
        <Route
          path={ORDER_ROUTES.canceled}
          element={
            <FailureScreen
              title="Purchase Canceled"
              screenName="canceled"
            />
          }
        />
        <Route
          path={ORDER_ROUTES.error}
          element={
            <FailureScreen
              title="Some error occurred"
              screenName="error page"
            />
          }
        />
        <Route
          path={ORDER_ROUTES.refund}
          element={<RefundScreen />}
        />
        <Route
          path={STATUS_ROUTES.notSupported}
          element={<NotSupportedScreen />}
        />
        <Route
          path={STATUS_ROUTES.notConnected}
          element={<NotConnectedScreen />}
        />
        <Route
          path={SERVICE_ROUTES.main}
          element={<ServiceMain />}
        />
        <Route path={SERVICE_ROUTES.complete} element={<ServiceComplete />} />
        <Route path={SERVICE_ROUTES.fail} element={<ServiceFail />} />
        <Route path={SERVICE_ROUTES.robot} element={<ServiceRobot />} />
        <Route path={SERVICE_ROUTES.wait} element={<ServiceWait />} />
        <Route
          path={FEEDBACK_ROUTES.smile}
          element={<SmilePage />}
        />
        <Route
          path={FEEDBACK_ROUTES.checkbox}
          element={<CheckboxPage />}
        />
        <Route
          path={FEEDBACK_ROUTES.wishes}
          element={<WishesPage />}
        />
        <Route
          path={FEEDBACK_ROUTES.contact}
          element={<ContactPage />}
        />
        <Route
          path={FEEDBACK_ROUTES.complete}
          element={<CompletePage />}
        />
        <Route
          path={PAYMENT_ROUTES.carWash}
          element={
            <LoyaltyLayout>
              <CarWashScreen />
            </LoyaltyLayout>
          }
        />
        <Route
          path={APP_ROUTES.sessionExpired}
          element={<OldTabScreen title="Session timed out" />}
        />
        {IS_LOCAL_DEVELOPMENT && (
          <Route path={APP_ROUTES.devAnimations} element={<DevAnimations />} />
        )}
        {IS_LOCAL_DEVELOPMENT && (
          <Route path={APP_ROUTES.devGame} element={<DevGame />} />
        )}
        <Route path={APP_ROUTES.notFound} element={<Error404Screen />} />
      </Route>
    </Routes>
  );
};

export { AppRouter };
